<template>
  <v-card elevation="2" :style="{ background: color, width: imageHeight ? imageHeight * aspectRatio + 'px' : 'auto' }" class="document-card">
    <v-toolbar height="40" v-if="title" flat :color="topColor || getBusinessProcessState(document?.approve_mask, 'color')" :dark="topDark">
        <v-toolbar-title><text-ellipsis :max-width="imageHeight ? 2 * imageHeight * aspectRatio + 'px' : '300px'">{{ title }}</text-ellipsis></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-menu
        bottom
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title><v-icon small>{{ icons.mdiPencil }}</v-icon> Редактировать</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title><v-icon small>{{ icons.mdiDelete }}</v-icon> Удалить</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-toolbar>
      <!-- Вариант preview документа -->
<!--      <div class="iframe-wrap">
          <iframe src="http://roscongress-cms-back/api/4df2d6f9-1adc-40bb-a0aa-5f1884cc47ee/report/1/download/?html=1"></iframe>
      </div>-->
    
    <v-img
      v-if="image !== false"
      :aspect-ratio="aspectRatio"
      :style="{aspectRatio}"
      :class="imageClass"
      lazy-src=""
      max-width="100%"
      :width="imageHeight ? imageHeight * aspectRatio + 'px' : '100%'"
      :height="imageHeight"
      transition="fade-transition"
      :src="image"
      :contain="contain"
    >
      <template v-slot:placeholder>
        <v-row align="center" class="fill-height ma-0" justify="center">
          <v-progress-circular
            color="grey lighten-5"
            indeterminate
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-card-text class="pa-0"><slot /></v-card-text>
    <v-card-title  class="bottom-title" v-if="bottomTitle">{{ bottomTitle }}</v-card-title>
    <v-card-actions v-if="actions && actions.length" class="document-actions">
        <div class="document-status" v-if="document" v-html="getBusinessProcessState(document.approve_mask)"></div>
        <v-btn v-if="actions.includes('edit')"  @click="$emit('action', ['edit', id])" class="mx-2" fab dark x-small color="red"><v-icon small dark>{{ icons.mdiPencil }}</v-icon></v-btn>
        <v-btn v-if="actions.includes('delete')" @click="$emit('action', ['delete', id])" class="mx-2" fab dark x-small color="grey darken-2"><v-icon small dark>{{ icons.mdiDelete }}</v-icon></v-btn>
        <v-btn v-if="actions.includes('export')" @click="$emit('action', ['export', id])" class="mx-2" fab dark x-small color="red"><v-icon small dark>mdi-file-pdf-box</v-icon></v-btn>
        <v-btn v-if="actions.includes('settings')" @click="$emit('action', ['settings', id])" class="mx-2" fab dark x-small color="blue"><v-icon small dark>mdi-cog</v-icon></v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mdiPencil, mdiShareVariant, mdiDelete } from '@mdi/js'
import BusinessProcess from "@/mixins/BusinessProcess";
import TextEllipsis from "@/components/commonComponents/TextEllipsis.vue";
export default {
  name: 'DocumentPreview',
    components: {TextEllipsis},
  mixins: [
      BusinessProcess,
  ],
  props: {
    value: Object,
    bottomTitle: [String, Number],
    image: [String, Boolean],
    color: String,
    topColor: String,
    topDark: Boolean,
    imageHeight: {
      type: Number,
      default: 200,
    },
    aspectRatio: {
      type: Number,
      default: 210/297,
    },
    contain: Boolean,
    imageClass: String,
    staticTitle: String,
  },
  data: () => ({
    icons: {
      mdiPencil,
      mdiShareVariant,
      mdiDelete,
    },
    isShowCardMenu: false,
  }),
  computed: {
    document() {
      return this.value;
    },
    permissions() {
      return this.document?.permissions || {};
    },
    actions() {
      const actions = [];
      if (!this.permissions) {
        return actions;
      }
      /* == PERMISSIONS ==
        canApproveAsApprover
        canApproveAsEditor
        canApproveAsModerator
        canDelete
        canPublish
        canRead
        canUpdate */
      this.permissions.canDelete && actions.push('delete');
      this.permissions.canRead && actions.push('export');
      this.permissions.canUpdate && actions.push('edit');
      this.permissions.canRead && actions.push('settings');
      this.permissions.canRead && !this.permissions.canUpdate && actions.push('view');
      return actions;
    },
    id() {
      return this.document?.id || 0;
    },
    title() {
      return this.document?.name || this.staticTitle || "";
    },
  },
  methods: {
  },
}
</script>
<style scoped lang="scss">
  .document-card {
    padding: 0;
    transition: all 0.3s ease-out;
    width: 100%;
    overflow: hidden;
    .bottom-title {
      justify-content: center;
      word-break: break-word;
      font-size: 0.55rem;
      line-height: 0.85rem;
      padding: 8px 16px;
      transition: all 0.3s ease-out;
    }
    .v-toolbar__title {
      font-size: 1.07rem;
      font-family: Roboto;
      font-weight: 600;
      line-height: 1.15;
      transition: all 0.3s ease-out;

        ::v-deep {
            .truncate {
                display: block;
                -webkit-box-orient: unset;
            }
        }
    }
    .document-actions {
      position: absolute;
      bottom: 0;
      transition: all 0.2s ease-out;
      justify-content: center;
      left: 0;
      right: 0;
      // transform: translateY(100%);
      flex-wrap: wrap;
      background: rgb(0,0,0);
      background: linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%);
      & > .v-btn.v-btn {
        padding: 0;
        margin: 3px !important;
      }
    }
    .document-status {
      display: block;
      width: 100%;
      text-align: center;
      line-height: 1em;
      padding: 4em 0.5em 1em;
      color: #fff;
    }
    ::v-deep .v-image__image {
      transition: all 0.2s ease-out;
    }
    &:hover {
      ::v-deep .v-image__image {
        transform: scale(1.15);
      }
      /**
      .document-actions {
        Иконки в кнопках не понимают, что они scale и перестают центрироваться, так что пока выключаю...
        //transform: scale(1.1) translateY(-10px);
      }
      */
    }
  }

  //.iframe-wrap {
  //    width:63.0mm;
  //    height: 89.1mm;
  //    padding: 0;
  //    overflow: hidden;
  //}
  //iframe {
  //    width:210mm;
  //    height: 297mm;
  //    transform: scale(0.3);
  //    transform-origin: 0 0;
  //    border: 0;
  //}
  
</style>
